module.exports = __webpack_public_path__ + "static/media/hotel_desk.b52a6727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/hotel_desk.png
// module id = 2393
// module chunks = 0